import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import AppRoot from './pages/AppRoot/AppRoot'
import { Provider } from 'react-redux'
import { BrowserRouter } from "react-router-dom";

import { saveCurrentState, store } from './store'
import CustomBrowserRouter from './CustomBrowserRouter'
import apphistory from './common/AppHistory'


function App() {
  // Zapis stanu do local lub session storage
  store.subscribe(()=>{
    saveCurrentState(store.getState())
  })

  return (
    <Provider store={store}>
      <CustomBrowserRouter history={apphistory}>
        <AppRoot />
      </CustomBrowserRouter>
    </Provider>
  )
}

export default App;